<template>
	<el-container id="own_examination">
        <div class="con"  v-loading="wait_for_loa">
            <div class="side">
                <div class="template_img">
                    <div class="hed">自学考试（{{$store.state.const.major_level.find(v=>{ return v.id == $store.state.major_level}).value}}）准考证</div>
                    <div class="certificate">
                        <div class="certificate_img">
                            <img  class="node_img" :src="global.oss_website+'/pc/images/jianbiantou.png'">
                        </div>
                        <div class="certificate_txt">
                            <div class="tit">姓名：</div>
                            <div class="userdata">{{user_data.nick_name}}</div>
                            <div class="tit" style="margin-top: 15px;">准考证号：<el-button size="mini" type="primary" @click="open_dialog(2)">修改</el-button> </div>
                            <div class="userdata">{{user_data.admission_ticket_number}}</div>
                        </div>
                    </div>
                </div>
                <div class="menu">
                    <div class="menu_con" :class="current_conten_text=='adopt'?'current_conten_class':''" @click="current_conten_fn('adopt')">
                        <div class="menu_icon">
                            <i class="iconfont" style="font-size: 24px;">&#xe68d;</i>
                        </div>
                        <div class="menu_data">
                            <div class="hed"><span class="fw">{{cum_sum}}</span>门</div>
                            <div class="tips">已通过课程</div>
                        </div>
                        <div class="set_txt">更新成绩<i class="iconfont">&#xe63a;</i></div>
                    </div>
                    <div class="menu_con" :class="current_conten_text=='wait_for'?'current_conten_class':''" @click="current_conten_fn('wait_for')">
                        <div class="menu_icon"><i class="iconfont" style="font-size: 28px;">&#xe698;</i></div>
                        <div class="menu_data">
                            <div class="hed"><span class="fw">{{exam_sum}}</span>门</div>
                            <div class="tips">待考课程</div>
                        </div>
                        <div class="set_txt">查看课程<i class="iconfont">&#xe63a;</i></div>
                    </div>
                    <div class="menu_con single_row" :class="current_conten_text=='query'?'current_conten_class':''" @click="current_conten_fn('query')">
                        <div class="menu_icon"><i class="iconfont" style="font-size: 26px;">&#xe67c;</i></div>
                        <div class="menu_data">成绩查询</div>
                        <div class="set_txt"><i class="iconfont">&#xe63a;</i></div>
                    </div>
                    <div class="menu_con single_row" :class="current_conten_text=='guide'?'current_conten_class':''" @click="current_conten_fn('guide')">
                        <div class="menu_icon"><i class="iconfont" style="font-size: 28px;">&#xe667;</i></div>
                        <div class="menu_data">报考指南</div>
                        <div class="set_txt"><i class="iconfont">&#xe63a;</i></div>
                    </div>
                    <div class="guide" @click="current_conten_fn('guide')" v-if="current_conten_text=='guide'">
                        <p v-for="(zhinan_item,i) in zhinan_arr" :key="zhinan_item.id" :class="guide_type==i?'blue':''" @click="guide_type=i">{{zhinan_item.title}}</p>
                        <!-- <p :class="guide_type==2?'blue':''" @click="guide_type=2">新生报名流程</p>
                        <p :class="guide_type==3?'blue':''" @click="guide_type=3">考生报名流程</p> -->
                    </div>
                </div>
            </div>
            <div class="con_data">
                <div class="adopt_con" v-if="current_conten_text=='adopt'">
                    <div class="con_data_hed">
                        自考成绩
                        <span class="fr"><el-button size="mini" :type="radio_val===''?'info':'primary'" :disabled="radio_val===''"  @click="open_dialog(1)">更新成绩</el-button></span>
                        
                    </div>
                    <div class="adopt" v-if="score_list.length!==0">
                        <div class="adopt_hed">
                            <div class="adopt_hed_name">课程名称</div>
                            <div class="adopt_hed_achievement">成绩</div>
                        </div>
                        <div class="adopt_list_f">
                            <div class="adopt_list" v-for="(score,i) in score_list" :key="'adopt'+score.id">
                                <div class="adopt_list_left">
                                    <!-- ?score.is_adopt -->
                                    <el-radio v-model="radio_val" :label="i" :style="score.score3>=60?'color: #5777fe;font-weight: 700;':''">
                                        <span>{{score.course_mould?score.course_mould.course_code:''}}&nbsp;&nbsp;&nbsp;{{score.course?score.course.title:''}} <span :class="'elective_type elective_type'+score.course_mould.course_type">{{score.course_mould.course_type==1?'必考':(score.course_mould.course_type==2?'选考':'加考')}}</span> </span>
                                    </el-radio>
                                </div>
                                <div class="adopt_list_right" :style="score.score3>=60?'':'color: #ff0000;'">{{score.score3}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="nodata" v-if="score_list.length==0">
			        	<img :src="nodataImg">
			        	<p>待更新</p>
			        </div>
                </div>
                <div class="wait_for_con" v-loading="wait_for_loa" v-if="current_conten_text=='wait_for'">
                    <div class="con_data_hed">
                        考试安排
                    </div>
                    <div class="wait_for" v-for="(exam) in examination_list" :key="'plan'+exam.id">
                        <div class="wait_for_hed">{{exam.name}}</div>
                        <div class="wait_for_con" v-for="(test_time_obj,key) in exam.test_time_obj" :key="key">
                            <div class="wait_for_time">{{key}}</div>
                            <div class="wait_for_list" v-for="(list) in test_time_obj" :key="list.id">
                                <div class="wait_for_list_left">
                                    {{list.course_code}}&nbsp;&nbsp;&nbsp;{{list.course.title}}
                                    <span v-if="list.test_time_plan"><i class="iconfont">&#xe66d;</i> 推荐</span>
                                </div>
                                <div class="wait_for_list_right"> {{getTime(list.start_time,list.end_time)}} </div>
                            </div>
                        </div>
                    </div>
                    <div class="nodata" v-if="examination_list.length==0">
			        	<img :src="nodataImg">
			        	<p>待更新</p>
			        </div>
                </div>
                <div class="wait_for_con"  v-if="current_conten_text=='query'">
                    <div class="con_data_hed">
                        广东省自学考试成绩查询流程图
                    </div>
                    <div v-html="chengji_text"></div>
                </div>
                <div class="wait_for_con"  v-if="current_conten_text=='guide'">
                    <div v-for="(zhinan_item,i) in zhinan_arr" :key="zhinan_item.id+'_text'">
                        <div class="wait_for_con" v-if="guide_type==i">
                            <div class="con_data_hed">
                                {{zhinan_item.title}}
                            </div>
                            <div v-html="zhinan_item.content"></div>
                        </div>
                        
                    </div>
                    <!-- <div v-if="guide_type==2">
                        <div class="con_data_hed">
                            新生报名流程
                        </div>
                    </div>
                    <div v-if="guide_type==3">
                        <div class="con_data_hed">
                            考生报名流程
                        </div>
                    </div> -->
                    
                </div>
            </div>



            <el-dialog :title="dialog_title" :visible.sync="dialogFormVisible">
                <div v-html="describe_text" class="describe_text"></div>
                <el-form>
                    <el-form-item :label="dialog_label" label-width="100px">
                        <el-input v-model="score_update_val" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <!-- <el-button @click="dialogFormVisible = false">取 消</el-button> -->
                    <el-button type="primary" @click="score_update()">确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </el-container>
</template>
<script>
export default {
	name: 'own_examination'
    // adopt 通过
    // wait_for 等待
    // query 查询
    // guide 指南


    //指南分类 1在线报名操作流程 2新生报名流程 3考生报名流程
	,data () {
		return {
            current_conten_text:'adopt',
            examination_list:[],
            wait_for_loa:false,
            radio_val:'',
            score_list:[],
            user_data:{},
            dialog_title:'提示',
            score_update_val:'',
            dialog_label:'',
            dialogFormVisible:false,
            describe_text:'',
            cum_sum:0,
            exam_sum:0,
            type:'',
            guide_type:0,
            chengji_text:'',
            //报考指南
            zhinan_arr:[]
		}
	}
	,mounted:function(){
        this.get_list_score()
        this.get_examination_list()
        let token = this.$cookies.get("token")
		let url = this.global.serverSrc+this.global.qianzui+'/column/list?code=chengji-chaxun';
		this.$ajax.get(url).then(res => {
            let resData = res.data
            // console.log(res);
			if(resData.code==0){
                // console.log(resData);
                this.chengji_text = resData.data.remotely_news[0].content
                // console.log(this.chengji_text);
			}else if(resData.code==401){
				this.$message.error('请求错误');
			}else{
				// this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~');
			}
		})
        url = this.global.serverSrc+this.global.qianzui+'/column/list?code=baokao-zhinan';
		this.$ajax.get(url).then(res => {
            let resData = res.data
            // console.log(res);
			if(resData.code==0){
                // console.log(resData);
                this.zhinan_arr = resData.data?resData.data.remotely_news:[]
                console.log(this.zhinan_arr);
                
			}else if(resData.code==401){
				this.$message.error('请求错误');
			}else{
				// this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~');
			}
		})
	}
	,watch:{
	}
	,computed:{
	}
	,methods:{
        current_conten_fn(txt){
            if (txt=='wait_for') {
                this.get_examination_list()
            }
            this.current_conten_text = txt
        },
        //获取考试安排
        get_examination_list(){
            this.wait_for_loa = true
            let token = this.$cookies.get("token")
			let url = this.global.serverSrc+this.global.qianzui+'/examPlan/listExamPlan';
			this.$ajax.get(url).then(res => {
                this.wait_for_loa = false
                // console.log(res);
				let resData=res.data;
                this.exam_sum = 0
				if(resData.code==0){
                    resData.data.map((v)=>{
                        v.test_time_obj = {}
                        v.test_time.map((v2)=>{
                            let time = v2.start_time.slice(0,10)
                            this.exam_sum++
                            if (!v.test_time_obj[time]) {
                                v.test_time_obj[time] = []
                            }
                            v.test_time_obj[time].push(v2)
                        })
                    })
                    this.examination_list = resData.data
                    // console.log();
					// 已购课程列表
					// this.purchased_list = [...this.purchased_list, ...resData.data]
				}else if(resData.code==401){
					this.$message.error('请求错误');
				}else{
					// this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~');
				}
			})
        },
        //获取时间
        getTime(start_time,end_time){
            // start_time.slice(0,10) + ' ' + 
            return start_time.slice(11,16) + ' - ' + end_time.slice(11,16)
        },
        //自考成绩列表
        get_list_score(){
            this.wait_for_loa = true
            let token = this.$cookies.get("token")
			let url = this.global.serverSrc+this.global.qianzui+'/examPlan/list_score';
            this.cum_sum = 0
			this.$ajax.get(url).then(res => {
                this.wait_for_loa = false
                // console.log(res);
				let resData=res.data;
                // console.log(resData);
				if(resData.code==0){
                    this.score_list = resData.data.student_result?resData.data.student_result:[]
                    this.user_data = resData.data
                    this.cum_sum = this.score_list.filter((v)=>{
                        return v.is_adopt
                    }).length
                    // console.log();
					// 已购课程列表
					// this.purchased_list = [...this.purchased_list, ...resData.data]
				}else if(resData.code==401){
					this.$message.error('请求错误');
				}else{
					// this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~');
				}
			})
        },
        // 打开弹窗
        open_dialog(type){
            this.type = type
            // console.log(this.radio_val);
            if (type==1) {
                if (this.radio_val==='') {
                    this.$message.error('请选择需要修改的课程');
                    return false
                }
                this.describe_text = '<span>课程名称:</span>'+this.score_list[this.radio_val].course.course_code+'&nbsp;&nbsp;&nbsp;'+this.score_list[this.radio_val].course.title
                this.dialog_label='考试成绩'
                this.dialog_title='更新成绩'
            }else{
                this.describe_text = '<span>准考证号:</span>'+this.user_data.admission_ticket_number
                this.dialog_label='准考证号'
                this.dialog_title='修改准考证号'
            }
            this.score_update_val = ''
            this.dialogFormVisible = true
        },
        //修改准考号或者成绩
        score_update(){
            if (this.score_update_val==='') {
                this.$message.error('请填写值！');
                return false
            }
            let token = this.$cookies.get("token")
			let url = this.global.serverSrc+this.global.qianzui+'/examPlan/score_update';
            let data = {
                type:this.type
            }
            if (this.type==1) {
                data.id = this.score_list[this.radio_val].id
                data.score = this.score_update_val
            }else{
                data.id = this.user_data.user_relation_id
                data.admission_ticket_number = this.score_update_val
            }
			this.$ajax.post(url,this.$qs.stringify(data)).then(res => {
                console.log(res);
                let resData = res.data
				if(resData.code==0){
                    if (this.type==1) {
                        this.score_list[this.radio_val].score3 = this.score_update_val
                    }else{
                        this.user_data.admission_ticket_number = this.score_update_val
                    }
                    this.dialogFormVisible = false
				}else if(resData.code==401){
					this.$message.error('请求错误');
				}else{
					// this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~');
				}
			})
        },
	}
	,destroyed:function(){
	}
}
</script>
<!-- scoped单页面有效属性 -->

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/own_examination.vue